<nav class="navigation" data-test-id="navigation-root">
	<div class="l-container navigation__container" data-help-anchor="navbar">
		@if (!apiRoot.features.lfpr) {
			<a class="logo"
			   data-test-id="logo"
			   (click)="showSchiRDetails()"
			   matTooltip="Details zu SchiR anzeigen"
			   attr.aria-label="Details zu SchiR anzeigen"
			   attr.aria-haspopup="dialog">
				<img src="/assets/img/logo-image-black.svg" alt="Schiffsregister-Logo"/>
			</a>
		}
		@if (apiRoot.features.lfpr) {
			<a class="logo"
			   data-test-id="logo"
			   (click)="showSchiRDetails()"
			   matTooltip="Details zu eLuPfand anzeigen"
			   attr.aria-label="Details zu eLuPfand anzeigen"
			   attr.aria-haspopup="dialog">
				<img src="/assets/img/lfpr-logo-image-black.svg" alt="eLuPfand-Logo"/>
			</a>
		}
		<div class="navbar">
			<a class="c-button c-button--rounded focus-inwards-dark"
			   routerLink="/dashboard"
			   routerLinkActive="active"
			   data-test-id="dashboard-button"
			   [attr.aria-label]="'Dashboard'"
			   [matTooltip]="toolTipVisible ? 'Dashboard' : null">
				<i class="material-icons" aria-hidden="true">home</i>
				<span>Dashboard</span>
			</a>
			<a class="c-button c-button--rounded focus-inwards-dark"
			   *ifResource="apiRoot;hasLink:apiRootLinkRel.VERFAHRENS"
			   data-test-id="verfahren-button"
			   [attr.aria-label]="'Verfahren'"
			   [matTooltip]="toolTipVisible ? 'Verfahren' : null"
			   (click)="onClick()" (keyup)="onClick()">
				<i class="material-icons" aria-hidden="true">folder</i>
				<span>Verfahren</span>
			</a>
			<schir-int-client-verfahren-global-search data-test-id="verfahren-global-search-root"/>
			<a class="c-button c-button--rounded focus-inwards-dark" routerLink="/admin" routerLinkActive="active"
			   data-test-id="admin-button" *ifResource="apiRoot;hasLink:apiRootLinkRel.ADMIN"
			   [matTooltip]="toolTipVisible ? 'Administration' : null"
			   [attr.aria-label]="'Administration'">
				<i class="material-icons" aria-hidden="true">perm_data_setting</i>
				<span>Administration</span>
			</a>
			@if (isHelpButtonVisible) {
				<a class="c-button c-button--rounded focus-inwards-dark"
				   (click)="showHelp()"
				   data-test-id="help-button"
				   matTooltip="Hilfe"
				   attr.aria-label="Hilfe">
					<i class="material-icons" aria-hidden="true">help</i>
					<span>Hilfe</span>
				</a>
			}
		</div>
		<schir-int-client-settings-menu [apiRoot]="apiRoot"/>
	</div>
</nav>
